module.exports = __webpack_public_path__ + "static/media/brasil-flag.b6e7fc31.png";